import { ConflictResolutionType } from 'business/models/Models';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { FmlxCheckBox, FmlxRadioButton } from 'fmlx-common-ui';
import React, { useContext } from 'react';
import { NewIngredientProps } from '../IngredientsConstants';
import IngredientsDetails from './IngredientsDetails';
import { newIngredientContext } from './IngredientsConflictsModel';
import { StocksTable } from './stocksTable';
import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';

export const NewIngredient = (props: NewIngredientProps) => {
  const {
    vendors,
    setIsUseVendorStock,
    setIsAddMissingStock,
    setVendorStock,
    vendorStock,
    isUseVendorStock,
    isAddMissingStock,
    onChangeIngredientType,
  } = props;
  const {
    selectedIngredient,
    setSelectedIngredient,
    conflictResolutionType,
    selectedTypes,
    setSelectedTypes,
    selectedAliases,
    setSelectedAliases,
    selectedCasNumbers,
    setSelectedCasNumbers,
    selectedBufferData,
    selectedIds,
    setSelectedIds,
    setSelectedBufferData,
    onClickAddTypes,
    onClickAddAliases,
    onClickAddCasNumbers,
    onClickAddBufferData,
    onClickDeleteTypes,
    onClickDeleteAliases,
    onClickDeleteCasNumbers,
  } = useContext(newIngredientContext);

  const vendorList: IDropDownList[] = vendors?.map((vendor) => {
    return {
      label: vendor.name,
      onClick: () => {
        setVendorStock(vendor.name);
      },
    };
  });

  const onChangeMissingStocksOptions = () => {
    setIsUseVendorStock(false);
    setIsAddMissingStock(!isAddMissingStock);
  };
  const onChangeExistingStocksOption = () => {
    setIsAddMissingStock(false);
    setIsUseVendorStock(!isUseVendorStock);
  };
  return (
    <>
      <div id='newingredients-wrapper' className="flex-flow p-2 border-box new-ingredient-box">
        <FmlxRadioButton
          id='newingredients-addnew-radiobutton'
          items={[
            {
              content: 'Add New Ingredient',
              disabled: false,
              hint: '',
              type: 'information',
            },
          ]}
          onChange={() => onChangeIngredientType(ConflictResolutionType.UseNew)}
          selectedIndex={
            conflictResolutionType === ConflictResolutionType.UseNew ? 0 : -1
          }
        />
        <hr id="newingredients-divider-top"  className="hr-line" />
        <h6 id="newingredients-stockoptions-title">
          <strong>Stocks Ingredients Options</strong>
        </h6>
        <FmlxCheckBox
          id="newingredients-addmissingstocks-checkbox"
          label="Always add missing stocks"
          checked={isAddMissingStock}
          onChange={onChangeMissingStocksOptions}
        />
        <div id="newingredients-existingstock-wrapper" className="existing-stock-div">
          <FmlxCheckBox
            id="newingredients-useexistingstocks-checkbox"
            label="If possible, use existing stocks from "
            checked={isUseVendorStock}
            onChange={onChangeExistingStocksOption}
          />
          <RMCustomButton
            key="1"
            title={vendorStock}
            dropDownList={vendorList}
            contentContainerClass="stock-select"
            onClick={() => {}}
            showBorder
            showChevronIcon
          />
        </div>
        <hr id="newingredients-divider-middle" className="hr-line" />
        <h6 id="newingredients-incomingingredients-title">
          <strong>Incoming Ingredients</strong>
        </h6>
        <IngredientsDetails
          conflictResolutionType={ConflictResolutionType.UseNew}
          selectedIngredient={selectedIngredient}
          setSelectedIngredient={setSelectedIngredient}
          setSelectedTypes={setSelectedTypes}
          selectedTypes={selectedTypes}
          setSelectedAliases={setSelectedAliases}
          selectedAliases={selectedAliases}
          setSelectedCasNumbers={setSelectedCasNumbers}
          selectedCasNumbers={selectedCasNumbers}
          setSelectedBufferData={setSelectedBufferData}
          selectedBufferData={selectedBufferData}
          onClickAddTypes={onClickAddTypes}
          onClickAddAliases={onClickAddAliases}
          onClickAddCasNumbers={onClickAddCasNumbers}
          onClickAddBufferData={onClickAddBufferData}
          onClickDeleteTypes={onClickDeleteTypes}
          onClickDeleteAliases={onClickDeleteAliases}
          onClickDeleteCasNumbers={onClickDeleteCasNumbers}
        />
        <div id="newingredients-incomingstocks-wrapper">
          <RMTableHeadingWithAddRemoveBtns
            tableHeading="Incoming Stocks"
            showAddButton={false}
            showDeleteButton={false}
          />
          <StocksTable
            ingredientStocks={selectedIngredient?.ingredientStock}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
          />
        </div>
      </div>
    </>
  );
};
